import styled from "@emotion/styled";

export const LeadAssignmentsPageTableHelperText = styled.span(({ theme }) => ({
	...theme.project.typography.body.body2,
	color: theme.project.colors.fontColors.secondary
}));

export const LeadAssignmentsPageTableContainer = styled.div({
	overflowX: "auto",
	width: "100%",
	minWidth: 0,
	WebkitOverflowScrolling: "touch"
});
